import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.038 21c-8.55-3.325-2.544-8.457-.701-5.292C24 22 5.537 21.944 4.5 19 3.462 16.056 3.463 7.7 3.463 7.7m0 0V5.298c0-1.033.838-1.87 1.865-1.862h12.97c1.028 0 1.866.837 1.866 1.862V7.7H3.463"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.038 21c-8.55-3.325-2.544-8.457-.701-5.292C22.335 19.14 17.75 20.683 13 20.9"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.687 3.395V2M16.096 3.272V2"
    />
  </svg>
);
export const Calendar02Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
